const CACHE_PREFIX = 'safe-read-cache'
const DEFAULT_TTL = 24 * 60 * 60 * 1000

const getCacheKey = (key) => `${CACHE_PREFIX}:${key}`

const canUseStorage = () => {
  try {
    return typeof window !== 'undefined' && Boolean(window.localStorage)
  } catch (error) {
    return false
  }
}

const readCache = (key) => {
  if (!canUseStorage()) {
    return null
  }

  try {
    const raw = window.localStorage.getItem(getCacheKey(key))
    return raw ? JSON.parse(raw) : null
  } catch (error) {
    return null
  }
}

const writeCache = (key, data, ttl) => {
  if (!canUseStorage()) {
    return
  }

  try {
    window.localStorage.setItem(
      getCacheKey(key),
      JSON.stringify({
        data,
        expiresAt: Date.now() + ttl,
      })
    )
  } catch (error) {
    // Storage can fail in private mode or when quota is exceeded. The app should keep working.
  }
}

const isCacheValid = (cached) => cached?.expiresAt && cached.expiresAt > Date.now()

export const getCachedReadOnlyData = async (key, fetcher, { ttl = DEFAULT_TTL } = {}) => {
  const cached = readCache(key)

  try {
    const data = await fetcher()
    writeCache(key, data, ttl)
    return data
  } catch (error) {
    if (isCacheValid(cached)) {
      return cached.data
    }

    throw error
  }
}

export const clearReadOnlyCache = () => {
  if (!canUseStorage()) {
    return
  }

  Object.keys(window.localStorage)
    .filter((key) => key.startsWith(`${CACHE_PREFIX}:`))
    .forEach((key) => window.localStorage.removeItem(key))
}
